export default __webpack_public_path__ + "static/media/table.6c259f79.png";